const dashboard = {
  // Page-level
  "dashboard.title": "Dashboard",
  "dashboard.connectPrompt": "Connect WhatsApp to get started",
  "dashboard.session": "Session",
  "dashboard.plan": "Plan",
  "dashboard.loading": "Loading dashboard...",
  "dashboard.error.title": "Failed to Load Data",
  "dashboard.error.needReconnect": "Your WhatsApp session needs to be reconnected. Restarting the scan will let you scan a new QR code.",
  "dashboard.error.restartScan": "Restart Scan",
  "dashboard.tabs.overview": "Overview",
  "dashboard.tabs.automation": "Automation",
  "dashboard.tabs.knowledge": "Knowledge Base",
  "dashboard.tabs.blacklist": "Blacklist",
  "dashboard.tabs.whatsapp": "WhatsApp",
  "dashboard.tabs.crm": "CRM",
  "dashboard.tabs.catalog": "Catalog",
  "dashboard.quickInfo.plan": "Plan",
  "dashboard.quickInfo.session": "Session",
  "dashboard.quickInfo.csvRows": "CSV Rows",
  "dashboard.quickInfo.blacklisted": "Blacklisted",
  "dashboard.toast.disconnected": "WhatsApp session disconnected. Restarting scan...",
  "dashboard.quickInfo.title": "Quick Info",

  // StatsCards
  "stats.totalUsage": "Total Usage",
  "stats.averageUsage": "Average usage across all resources",
  "stats.trendingUp": "Your overall usage is trending up. Consider upgrading soon.",
  "stats.trendingDown": "Your overall usage is trending down.",
  "stats.trendingFlat": "Your overall usage is trending flat.",
  "stats.exceededLimit": " You've exceeded your plan limit on some resources. ",
  "stats.upgradePrompt": "Upgrade your plan to increase limits.",
  "stats.messages": "Messages",
  "stats.tokens": "Tokens",
  "stats.inputTokens": "Input Tokens",
  "stats.outputTokens": "Output Tokens",
  "stats.of": "of",
  "stats.usageStatistics": "Usage Statistics",
  "stats.last7Days": "Last 7 days trend",

  // ChatListSidebar
  "chatList.title": "Chats",
  "chatList.bulkMessage": "Bulk Message",
  "chatList.crmPipeline": "CRM Pipeline",
  "chatList.refreshChats": "Refresh chats",
  "chatList.searchPlaceholder": "Search or start a new chat",
  "chatList.filterAll": "All",
  "chatList.filterUnread": "Unread",
  "chatList.filterGroups": "Groups",
  "chatList.tryAgain": "Try again",
  "chatList.noChats": "No chats yet",
  "chatList.you": "You",
  "chatList.yesterday": "Yesterday",
  "chatList.archived": "Archived",
  "chatList.photo": "Photo",
  "chatList.video": "Video",
  "chatList.voiceMessage": "Voice Message",
  "chatList.audio": "Audio",
  "chatList.document": "Document",
  "chatList.location": "Location",
  "chatList.sticker": "Sticker",
  "chatList.contact": "Contact",
  "chatList.poll": "Poll",
  "chatList.gif": "GIF",
  "chatList.product": "Product",
  "chatList.call": "Call",
  "chatList.catalog": "Catalog",
  "chatList.order": "Order",
  "chatList.template": "Template",
  "chatList.button": "Button",
  "chatList.interactiveMessage": "Interactive Message",
  "chatList.disappearingMessage": "Disappearing Message",
  "chatList.groupEvent": "Group Event",
  "chatList.notification": "Notification",
  "chatList.broadcast": "Broadcast",

  // ChatWindow
  "chatWindow.title": "WhatsApp Chat",
  "chatWindow.emptyText": "Select a conversation from the list to start chatting. Messages update in real time.",
  "chatWindow.group": "Group",
  "chatWindow.business": "Business",
  "chatWindow.refreshMessages": "Refresh messages",
  "chatWindow.today": "Today",
  "chatWindow.yesterday": "Yesterday",
  "chatWindow.noMessages": "No messages yet",
  "chatWindow.startConversation": "Send a message to start the conversation",
  "chatWindow.back": "Back",

  // ChatInput
  "chatInput.aiReplying": "AI is generating a reply...",
  "chatInput.shareLocation": "Share Location",
  "chatInput.locationName": "Location name *",
  "chatInput.address": "Address",
  "chatInput.latitude": "Latitude *",
  "chatInput.longitude": "Longitude *",
  "chatInput.sending": "Sending...",
  "chatInput.sendLocation": "Send Location",
  "chatInput.shareLink": "Share Link",
  "chatInput.url": "URL *",
  "chatInput.captionOptional": "Caption (optional)",
  "chatInput.sendLink": "Send Link",
  "chatInput.recordVoice": "Record voice",
  "chatInput.attach": "Attach",
  "chatInput.typeMessage": "Type a message",

  // WhatsAppSessionPanel
  "wpp.readyToConnect": "Ready to connect",
  "wpp.generatingToken": "Generating token...",
  "wpp.tokenGenerated": "Token generated",
  "wpp.startingSession": "Starting session...",
  "wpp.waitingForQR": "Waiting for QR scan",
  "wpp.sessionConnected": "Session connected",
  "wpp.connectionError": "Connection error",
  "wpp.stepToken": "Token",
  "wpp.stepQR": "QR Code",
  "wpp.stepConnected": "Connected",
  "wpp.noSession": "No session available. Please log in first.",
  "wpp.title": "WhatsApp Session",
  "wpp.sessionLabel": "Session:",
  "wpp.statusConnected": "Connected",
  "wpp.statusWaiting": "Waiting",
  "wpp.statusGenerating": "Generating",
  "wpp.statusStarting": "Starting",
  "wpp.statusChecking": "Checking",
  "wpp.reset": "Reset",
  "wpp.connectPrompt": "Generate a token and start your WhatsApp session to connect your number.",
  "wpp.connectBtn": "Connect WhatsApp",
  "wpp.generatingDesc": "Generating secure token...",
  "wpp.generatingSub": "Contacting server for authentication",
  "wpp.startingDesc": "Starting WhatsApp session...",
  "wpp.startingSub": "Initializing connection",
  "wpp.tokenReady": "Token generated successfully",
  "wpp.startSession": "Start Session",
  "wpp.scanTitle": "Scan with WhatsApp",
  "wpp.scanDesc": "Open WhatsApp on your phone, go to <strong>Settings &gt; Linked Devices</strong>, and scan this QR code.",
  "wpp.checkNow": "Check Now",
  "wpp.startOver": "Start Over",
  "wpp.autoCheck": "Auto-checking every 5 seconds...",
  "wpp.connectedTitle": "WhatsApp is Connected",
  "wpp.connectedDesc": "Your session {{name}} is active and ready.",
  "wpp.verifyConnection": "Verify Connection",
  "wpp.errorTitle": "Error",

  // AutomationPanel
  "automation.title": "Automation Controls",
  "automation.statusUpdated": "Status updated!",
  "automation.failedUpdate": "Failed to update",
  "automation.statusTitle": "Automation Status",
  "automation.statusActive": "Bot is actively replying to messages",
  "automation.statusPaused": "Bot is currently paused",
  "automation.lastUpdated": "Last updated:",
  "automation.replySettings": "Reply Settings",
  "automation.replySettingsUpdated": "Reply settings updated!",
  "automation.voiceMessages": "Voice Messages",
  "automation.voiceDesc": "Auto-reply with voice notes",
  "automation.imageReplies": "Image Replies",
  "automation.imageDesc": "Auto-reply with images",
  "automation.documentReplies": "Document Replies",
  "automation.documentDesc": "Auto-reply with documents",

  // KnowledgeBasePanel
  "kb.title": "Knowledge Base",
  "kb.subtitle": "Business info + {{products}} product{{plural}} combined into one data.csv",
  "kb.businessSection": "Business Information",
  "kb.businessDesc": "Company profile & service details",
  "kb.productSection": "Product Information",
  "kb.productDesc": "Add products for RAG knowledge",
  "kb.productDescWithCount": "{{count}} product{{plural}} · {{fields}} fields filled",
  "kb.importCsv": "Import via CSV",
  "kb.addProduct": "Add Product",
  "kb.submitCsv": "Submit as data.csv",
  "kb.submitting": "Submitting...",
  "kb.fillRequired": "Fill in at least one field before submitting",
  "kb.submitSuccess": "Submitted! {{fields}} fields across {{sections}} sections sent as data.csv ({{rows}} rows).",
  "kb.submitFailed": "Submission failed",
  "kb.fieldsFilled": "{{total}} fields filled across {{sections}} sections",
  "kb.fieldsCount": "{{filled}}/{{total}} fields",
  "kb.removeProduct": "Remove product",
  "kb.productDefault": "Product {{index}}",
  // Business fields
  "kb.field.name": "Business Name",
  "kb.field.namePlaceholder": "Company or business name",
  "kb.field.industry": "Industry",
  "kb.field.industryPlaceholder": "e.g. Software Development & Digital Solutions",
  "kb.field.description": "Description",
  "kb.field.descriptionPlaceholder": "Brief description of the business",
  "kb.field.email": "Email",
  "kb.field.emailPlaceholder": "contact@example.com",
  "kb.field.website": "Website",
  "kb.field.websitePlaceholder": "https://example.com",
  "kb.field.workingHours": "Working Hours",
  "kb.field.workingHoursPlaceholder": "e.g. Daily from 9 AM to 5 PM",
  "kb.field.address": "Address",
  "kb.field.addressPlaceholder": "Physical address",
  "kb.field.serviceMonthly": "Monthly Service",
  "kb.field.serviceMonthlyPlaceholder": "Description of monthly service offerings",
  "kb.field.serviceQuarterly": "Quarterly Service",
  "kb.field.serviceQuarterlyPlaceholder": "Description of quarterly service offerings",
  "kb.field.serviceTrainer": "Training Service",
  "kb.field.serviceTrainerPlaceholder": "Description of training offerings",
  // Product fields
  "kb.field.productName": "Product Name",
  "kb.field.productNamePlaceholder": "e.g. Wireless Bluetooth Headphones Pro X200",
  "kb.field.productDescription": "Description",
  "kb.field.productDescriptionPlaceholder": "Detailed description of the product",
  "kb.field.category": "Category",
  "kb.field.categoryPlaceholder": "e.g. Electronics, Fashion, Home & Garden",
  "kb.field.brand": "Brand",
  "kb.field.brandPlaceholder": "e.g. Apple, Samsung, Nike",
  "kb.field.price": "Price",
  "kb.field.pricePlaceholder": "e.g. 299.99",
  "kb.field.features": "Key Features",
  "kb.field.featuresPlaceholder": "Main features and specifications separated by commas",
  "kb.field.inventoryStatus": "Inventory Status",
  "kb.field.inventoryStatusPlaceholder": "e.g. In Stock, Out of Stock, Pre-order",
  "kb.field.productUrl": "Product URL",
  "kb.field.productUrlPlaceholder": "https://example.com/product",

  // BlacklistPanel
  "blacklist.title": "Blacklist",
  "blacklist.addNumber": "Add Number",
  "blacklist.phonePlaceholder": "Enter phone number (e.g. 201234567890)",
  "blacklist.block": "Block",
  "blacklist.invalidPhone": "Enter a valid phone number (10-15 digits, no +)",
  "blacklist.addedSuccess": "Number added to blacklist",
  "blacklist.addedFailed": "Failed to add number",
  "blacklist.removedSuccess": "Number removed",
  "blacklist.removedFailed": "Failed to remove",
  "blacklist.empty": "Blacklist is empty. All numbers can interact with the bot.",
  "blacklist.blockedCount": "Blocked numbers: {{count}}",

  // BulkMessagingPanel
  "bulk.title": "Bulk Messaging",
  "bulk.messageComposer": "Message Composer",
  "bulk.simple": "Simple",
  "bulk.advanced": "Advanced",
  "bulk.messagePlaceholder": "Hi {{name}}! We have an exclusive offer just for you...",
  "bulk.charCount": "{{{count}}} / 4096",
  "bulk.insertVariables": "Insert dynamic variables to personalize messages",
  "bulk.name": "Name",
  "bulk.phone": "Phone",
  "bulk.attach": "Attach",
  "bulk.delayTitle": "Delay Between Messages",
  "bulk.delayDesc": "Reduces spam detection risk. Recommended: 5–15s",
  "bulk.sec": "sec",
  "bulk.randomDelay": "Random Delay",
  "bulk.scheduleTitle": "Schedule Send",
  "bulk.date": "Date",
  "bulk.time": "Time",
  "bulk.campaignScheduled": "Campaign Scheduled",
  "bulk.preview": "Preview",
  "bulk.previewEmpty": "Your message will appear here...",
  "bulk.justNow": "Just now",
  "bulk.contacts": "Contacts",
  "bulk.contactsFormat": "phone, name format",
  "bulk.importCsv": "Import CSV",
  "bulk.clearAll": "Clear all",
  "bulk.sendAll": "Send All",
  "bulk.stopSending": "Stop sending",
  "bulk.scheduleSend": "Schedule Send",
  "bulk.sendingMessages": "Sending messages...",
  "bulk.noContacts": "No contacts found",
  "bulk.importPrompt": "Import a CSV or connect WhatsApp to load contacts",
  "bulk.scheduledBanner": "Sending starts {{date}}, {{time}}",
  "bulk.recipientsWillReceive": "{{count}} contact{{plural}} will receive the message",
  "bulk.cancel": "Cancel",
  "bulk.all": "All",
  "bulk.pending": "Pending",
  "bulk.sent": "Sent",
  "bulk.failed": "Failed",
  "bulk.nameColumn": "Name",
  "bulk.phoneColumn": "Phone",
  "bulk.statusColumn": "Status",
  "bulk.backToChats": "Back to chats",
  "bulk.mobileTabMessage": "Message",
  "bulk.mobileTabContacts": "Contacts",
  "bulk.csvImportSuccess": "Imported {{count}} contact{{plural}}",
  "bulk.csvDuplicates": "{{count}} duplicate{{plural}} skipped",
  "bulk.csvNoPhone": "{{count}} row{{plural}} missing phone",
  "bulk.csvNoNew": "No new contacts added.",
  "bulk.csvInvalidType": "Invalid file type. Please upload a .csv file.",
  "bulk.csvTooLarge": "File is too large ({{size}}MB). Maximum size is 5MB.",
  "bulk.csvReadError": "Failed to read the file. Make sure it's a valid CSV file.",
  "bulk.csvNoData": "No valid data rows found in the file.",
  "bulk.csvNoHeaders": "No valid headers found.",
  "bulk.csvHeadersOnly": "File has headers only — no data rows found.",
  "bulk.csvColumnMismatch": "Row {{row}}: expected {{expected}} columns, got {{got}}. Row skipped.",
  "bulk.csvEmpty": "File is empty.",
  "bulk.pagination": "{{start}}-{{end}} of {{total}}",
  "bulk.scheduleTimeFuture": "Scheduled time must be in the future.",
  "bulk.failedToSend": "Failed to send message",
  "bulk.switchFixedDelay": "Switch to Fixed delay",
  "bulk.switchRandomDelay": "Switch to Random delay",
  "bulk.switchSendNow": "Switch to Send Now",
  "bulk.switchSchedule": "Enable Schedule Send",
  "bulk.cancelSchedule": "Cancel schedule",
  "bulk.stopSendingTooltip": "Stop sending",
  "bulk.mobileRecipients": "{{{count}}} contacts - {{{status}}}",
  "bulk.statusPending": "Pending",
  "bulk.statusSent": "Sent",
  "bulk.statusFailed": "Failed",

  // MessageBubble
  "msg.photo": "Photo",
  "msg.video": "Video",
  "msg.audio": "Audio",
  "msg.voiceMessage": "Voice message",
  "msg.document": "Document",
  "msg.location": "Location",
  "msg.sticker": "Sticker",
  "msg.contact": "Contact",
  "msg.link": "Link",
  "msg.deleted": "This message was deleted",
  "msg.you": "You",
  "msg.loadingImage": "Loading image...",
  "msg.imageUnavailable": "Image unavailable",
  "msg.image": "Image",
  "msg.loadingVideo": "Loading video...",
  "msg.videoUnavailable": "Video unavailable",
  "msg.tapToOpenMap": "Tap to open map",
  "msg.openInMaps": "Open in Maps",
  "msg.file": "File",
  "msg.documentType": "Document",
  "msg.voiceCall": "Voice Call",
  "msg.videoCall": "Video Call",
  "msg.tapToCallBack": "Tap to call back",
  "msg.contactCard": "Contact card",

  // MessageActions
  "actions.reply": "Reply",
  "actions.aiReply": "Suggest Reply",
  "actions.copy": "Copy",
  "actions.react": "React",
  "actions.cancel": "Cancel",

  // AttachmentMenu
  "attach.image": "Image",
  "attach.document": "Document",
  "attach.location": "Location",
  "attach.link": "Link",

  // VoiceRecorder
  "voice.delete": "Delete",
  "voice.connecting": "Connecting...",
  "voice.resume": "Resume",
  "voice.pause": "Pause",
  "voice.send": "Send",

  // ReplyPreview
  "reply.replyTo": "Reply to",

  // CsvProductImporter
  "csvImporter.title": "Import Products via CSV",
  "csvImporter.subtitle": "Bulk import products into your knowledge base",
  "csvImporter.expectedColumns": "Expected CSV Columns",
  "csvImporter.column": "Column",
  "csvImporter.required": "Required",
  "csvImporter.optional": "Optional",
  "csvImporter.example": "Example",
  "csvImporter.requiredBadge": "Required",
  "csvImporter.optionalBadge": "Optional",
  "csvImporter.validationTitle": "Validation Rules",
  "csvImporter.valRequired": "Product Name and Product Description are <strong>required</strong> — rows missing them will be skipped",
  "csvImporter.valEmptyRows": "Empty rows are automatically ignored",
  "csvImporter.valPrice": "Price must be a valid number (e.g., 299.99)",
  "csvImporter.valDuplicates": "Duplicate products (by name) are detected and skipped",
  "csvImporter.valEncoding": "Supports UTF-8 encoding for Arabic and other languages",
  "csvImporter.valTrim": "All leading/trailing whitespace is trimmed from every field",
  "csvImporter.downloadTemplate": "Download sample CSV template",
  "csvImporter.dropHere": "Drop your file here",
  "csvImporter.clickToUpload": "Click to upload or drag & drop",
  "csvImporter.csvOnly": "CSV files only, UTF-8 encoding recommended",
  "csvImporter.processing": "Processing your CSV file...",
  "csvImporter.validating": "Validating data and checking for errors",
  "csvImporter.rowsRead": "Rows Read",
  "csvImporter.imported": "Imported",
  "csvImporter.failed": "Failed",
  "csvImporter.errorsTitle": "Import Errors ({{count}})",
  "csvImporter.fileError": "File",
  "csvImporter.rowError": "Row {{row}}",
  "csvImporter.readyTitle": "Products Ready to Import ({{count}})",
  "csvImporter.uploadAnother": "Upload Another File",
  "csvImporter.cancel": "Cancel",
  "csvImporter.importBtn": "Import {{count}} Product{{plural}}",
  "csvImporter.invalidFileType": "Invalid file type. Please upload a .csv file.",
  "csvImporter.noHeaderColumns": "No recognized product columns found in the header. Please check the column names.",
  "csvImporter.missingRequiredCols": "The CSV must include at least 'Product Name' and 'Product Description' columns.",
  "csvImporter.missingName": "Product Name is required and is missing.",
  "csvImporter.missingDesc": "\"{{name}}\" is missing a Product Description, which is required.",
  "csvImporter.invalidPrice": "\"{{name}}\" has an invalid price: \"{{price}}\". Must be a valid number.",
  "csvImporter.duplicate": "\"{{name}}\" already exists in your product list. Duplicate skipped.",
  "csvImporter.dupInCsv": "\"{{name}}\" appears multiple times in the CSV. Duplicate skipped.",
  "csvImporter.readFailed": "Failed to read the file. Please ensure it is a valid UTF-8 CSV file.",

  // Charts
  "charts.usageTrends": "Usage Trends",
  "charts.last30Days": "Last 30 days · tokens & messages",
  "charts.tokens": "Tokens",
  "charts.messages": "Messages",
  "charts.input": "Input",
  "charts.output": "Output",
  "charts.tokenSplit": "Token Split",
  "charts.inputVsOutput": "Input vs Output distribution",
  "charts.inputRatio": "Input ratio",
  "charts.planCapacity": "Plan Capacity",
  "charts.usageVsLimits": "Usage vs limits per feature",
  "charts.used": "used",
  "charts.dailyActivity": "Daily Activity",
  "charts.inputOutputPerDay": "Input & output tokens per day",
  "charts.activityCalendar": "Activity Calendar",
  "charts.activitySubtitle": "{{messages}} messages · {{days}} active days · last 4 weeks",
  "charts.less": "Less",
  "charts.more": "More",
  "charts.buildingHistory": "Building your activity history",
  "charts.buildingHistoryDesc": "Data accumulates each time you visit the dashboard. Come back tomorrow to see your first trend!",
  "charts.activeDays": "Active Days",
  "charts.of28": "{{days}} of 28",
  "charts.avgDaily": "Avg Daily",
  "charts.avgDailyMsgs": "{{msgs}} msgs",

  // CRM Pipeline
  "crm.title": "CRM Pipeline",
  "crm.tracked": "tracked",
  "crm.all": "All",
  "crm.noChats": "No chats loaded. Switch to WhatsApp tab to load conversations first.",
  "crm.untracked": "Not tracked",
  "crm.moveTo": "Move to stage",
  "crm.tags": "Tags",
  "crm.manageStage": "Manage Stage",
  "crm.addToLeadNew": "Add as Lead New",
  "crm.emptyStage": "No contacts in this stage yet",
  "crm.setupTitle": "CRM Pipeline Setup",
  "crm.setupDesc": "Create WhatsApp labels to track your leads through the sales pipeline — from new lead to closed customer. This is a one-time setup.",
  "crm.settingUp": "Setting up...",
  "crm.setupBtn": "Setup Pipeline Labels",
  "crm.confirmSetup": "Create Pipeline Labels?",
  "crm.confirmSetupDesc": "This will create {{count}} labels on your WhatsApp session: Lead New, In Contact, Negotiating, Customer, Lost — plus VIP and Complaint tags.",
  "crm.cancel": "Cancel",
  "crm.createLabels": "Create Labels",
  "crm.refreshLabels": "Refresh Labels",
  "crm.reset": "Reset",
  "crm.resetTitle": "Reset Pipeline?",
  "crm.resetDesc": "This will delete ALL CRM labels from WhatsApp and clear your local tracking data. This action cannot be undone.",
  "crm.confirmReset": "Delete All Labels",
  "crm.stage.leadnew": "Lead New",
  "crm.stage.incontact": "In Contact",
  "crm.stage.negotiating": "Negotiating",
  "crm.stage.customer": "Customer",
  "crm.stage.lost": "Lost",
  "crm.addCustomer": "Add Customer",
  "crm.addCustomerTitle": "Add New Customer",
  "crm.addCustomerDesc": "Add a customer that hasn't messaged yet to track them in the Pipeline.",
  "crm.countryCodeLabel": "Country Code",
  "crm.phoneLabel": "Phone Number",
  "crm.phonePlaceholder": "201234567890",
  "crm.digitsLeft": "{{count}} digits left",
  "crm.digitsLeftOne": "1 digit left",
  "crm.enterMoreDigits": "Enter {{count}} more digits",
  "crm.enterMoreDigitsOne": "Enter 1 more digit",
  "crm.phoneValid": "✓",
  "crm.nameLabel": "Customer Name",
  "crm.namePlaceholder": "Enter customer name",
  "crm.stageLabel": "Initial Stage",
  "crm.addBtn": "Add to Pipeline",
  "crm.adding": "Adding...",
  "crm.invalidPhone": "Enter a valid phone number ({{digits}} digits)",
  "crm.alreadyExists": "This number already exists in your chat list",
  "crm.manualEntry": "Manual Entry",
  "crm.importCsv": "Import CSV",
  "crm.importCsvTitle": "Import Customers from CSV",
  "crm.importCsvDesc": "Upload a CSV file with customer data to batch-add them to the Pipeline.",
  "crm.importCsvColumns": "Supported Columns",
  "crm.importCsvColumnPhone": "Phone (required)",
  "crm.importCsvColumnName": "Name (optional)",
  "crm.importCsvColumnStage": "Stage (optional)",
  "crm.importCsvStageDefault": "Default: Lead New",
  "crm.importCsvStageOptions": "Available options",
  "crm.importCsvDownloadTemplate": "Download CSV Template",
  "crm.importCsvDropHere": "Drop file here or click to upload",
  "crm.importCsvCsvOnly": "CSV files only",
  "crm.importCsvPreviewTitle": "Preview ({{count}} customer{{plural}})",
  "crm.importCsvNoValid": "No valid data found in file. Make sure there's a phone column.",
  "crm.importCsvWillImport": "Will import {{count}} customer{{plural}}",
  "crm.importCsvDuplicatesSkipped": "{{count}} duplicate{{plural}} skipped",
  "crm.importCsvInvalidFile": "Invalid file type. Please upload a .csv file.",
  "crm.importCsvReadError": "Failed to read file. Make sure it's a valid CSV.",
  "crm.importCsvBtn": "Import {{count}} Customer{{plural}}",
  "crm.importCsvEmpty": "File is empty or contains no valid data.",

  // Catalog
  "catalog.title": "Catalog Manager",
  "catalog.products": "products",
  "catalog.cart": "Cart",
  "catalog.enableCart": "Enable Cart",
  "catalog.disableCart": "Disable Cart",
  "catalog.refresh": "Refresh",
  "catalog.tabProducts": "Products",
  "catalog.tabCollections": "Collections",
  "catalog.searchProducts": "Search products...",
  "catalog.allProducts": "All Products",
  "catalog.addProduct": "Add Product",
  "catalog.noProducts": "No products in catalog yet",
  "catalog.addFirstProduct": "Add your first product to start selling",
  "catalog.noSearchResults": "No matching results",
  "catalog.noImage": "No image",
  "catalog.hidden": "Hidden",
  "catalog.edit": "Edit",
  "catalog.show": "Show",
  "catalog.hide": "Hide",
  "catalog.delete": "Delete",
  "catalog.editProduct": "Edit Product",
  "catalog.addProductBtn": "Add",
  "catalog.productName": "Product Name",
  "catalog.productNamePlaceholder": "e.g. Wireless Bluetooth Pro",
  "catalog.replaceImage": "Replace Image",
  "catalog.productImage": "Product Image",
  "catalog.clickToUpload": "Click to upload",
  "catalog.leaveEmptyToKeep": "Leave empty to keep current image",
  "catalog.description": "Description",
  "catalog.descriptionPlaceholder": "Product description",
  "catalog.price": "Price",
  "catalog.pricePlaceholder": "e.g. 299.99",
  "catalog.currency": "Currency",
  "catalog.productUrl": "Product URL",
  "catalog.productUrlPlaceholder": "https://example.com/product",
  "catalog.retailerId": "Retailer ID (SKU)",
  "catalog.retailerIdPlaceholder": "SKU001",
  "catalog.cancel": "Cancel",
  "catalog.saveChanges": "Save Changes",
  "catalog.productAdded": "Product added successfully",
  "catalog.productAddFailed": "Failed to add product",
  "catalog.productUpdated": "Product updated",
  "catalog.productUpdateFailed": "Failed to update product",
  "catalog.productDeleted": "Product deleted",
  "catalog.productDeleteFailed": "Failed to delete product",
  "catalog.productShown": "Product shown",
  "catalog.productHidden": "Product hidden",
  "catalog.visibilityFailed": "Failed to change visibility",
  "catalog.confirmDeleteProduct": "Delete Product?",
  "catalog.confirmDeleteCollection": "Delete Collection?",
  "catalog.cannotUndo": "This action cannot be undone.",
  "catalog.confirmDelete": "Confirm Delete",
  "catalog.collectionCount": "{{count}} collection",
  "catalog.createCollection": "Create Collection",
  "catalog.noCollections": "No collections yet",
  "catalog.createFirstCollection": "Create a collection to organize your products",
  "catalog.collectionName": "Collection Name",
  "catalog.collectionNamePlaceholder": "e.g. Electronics",
  "catalog.selectProducts": "Select Products",
  "catalog.noProductsForCollection": "No products available",
  "catalog.createCollectionBtn": "Create",
  "catalog.collectionCreated": "Collection created",
  "catalog.collectionCreateFailed": "Failed to create collection",
  "catalog.collectionUpdated": "Collection updated",
  "catalog.collectionUpdateFailed": "Failed to update collection",
  "catalog.collectionDeleted": "Collection deleted",
  "catalog.collectionDeleteFailed": "Failed to delete collection",
  "catalog.productsInCollection": "{{count}} product",
  "catalog.editCollection": "Edit Collection",
  "catalog.cartToggleFailed": "Failed to toggle cart",
  "bulk.sendingActive": "Active Bulk Campaign",
  "bulk.campaignScheduledShort": "Scheduled Send",
  "bulk.scheduledFor": "Scheduled for",
  "bulk.view": "View",
  "bulk.stopCampaign": "Stop",
  "bulk.sendingProgress": "Progress",
};

export default dashboard;